import {Col, Row} from 'antd';
import React from 'react';

import InformativeText from '../../../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import TotalChartList from '../../../../components/TotalChartList';
import ValueRepresentationBox from '../../../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../../../constants/commonConstants';
import AllSuppliers from '../../../../supplyChain/utils/AllSuppliers';

const OperationalFuel: React.FC<{data: any[]}> = ({data}) => {
  const fuelInfo = InformativeText?.NZM?.utility?.fuel;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(837)}}>
        <Col span={12}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(837)}}>
            <Col span={24}>
              <TotalChartList
                data={data}
                keyArray={[
                  'stationary vehicle fugitive emission scope 1',
                  'emission by machine',
                  'emission by vehicle',
                  'total fugitive emission'
                ]}
                chartType="multiProgress"
                tooltip={`${fuelInfo.Stationary_combustion} ${fuelInfo.Mobile_combustion} 
                ${fuelInfo.Fugitive_emissions}`}
              />
            </Col>
            <Col span={8}>
              <ValueRepresentationBox
                data={data}
                mainKey="emissions intensity per unit of fuel consumed"
                smallImage={true}
                tooltip={fuelInfo?.Emission_intensity_per_unit_of_fuel_consumed}
              />
            </Col>
            <Col span={8}>
              <ValueRepresentationBox
                data={data}
                mainKey="scope 1 emissions per employee"
                smallImage={true}
              />
            </Col>
            <Col span={8}>
              <ValueRepresentationBox
                data={data}
                mainKey="scope 1 emissions per unit of production or revenue"
                smallImage={true}
              />
            </Col>
            <Col span={8}>
              <ValueRepresentationBox
                data={data}
                mainKey="company owned vehicle fleet size"
                smallImage={true}
                tooltip={fuelInfo?.Company_owned_vehicle_fleet_size}
              />
            </Col>
            <Col span={8}>
              <ValueRepresentationBox
                data={data}
                mainKey="carbon emissions per kms driven"
                smallImage={true}
              />
            </Col>
            <Col span={8}>
              <ValueRepresentationBox
                data={data}
                mainKey="mileage per company owned vehicle"
                smallImage={true}
              />
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <AllSuppliers
            data={data}
            keyArray={['total scope 1 emission by facility']}
            type="fuelUtilityScope1"
            customTitle="TOTAL NO. OF FACILITY"
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
        <Col span={4}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey="frequency of inspection for fugitive emission sources"
                smallImage={true}
                tooltip={
                  fuelInfo?.Frequency_of_inspections_for_fugitive_emission_sources
                }
              />
            </Col>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey="emission of ozone-depleting substance"
                smallImage={true}
                tooltip={fuelInfo?.Emissions_of_ozone_depleting_substances}
              />
            </Col>
          </Row>
        </Col>
        <Col span={20}>
          <TotalChartList
            chartType="line"
            showTotal={false}
            keyArray={['scope 1 emission trends over time']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
      </Row>
    </>
  );
};

export default OperationalFuel;
